import React, { useMemo } from "react";
import { Group } from "react-konva";
import { getUnitPaths } from "../core/planTrainUnitCalculations";
import { PlanTrainUnitText } from "./PlanTrainUnitText";
import { PlanTrainUnitUnit } from "./PlanTrainUnitUnit";
import { PlanTrainUnit } from "@opstel/query/models/planTrainUnit";
import { Point } from "@opstel/geo/Point";
import { useEPDStyle } from "../contexts/EPDStyle/useEPDStyle";
import { IPath } from "@opstel/geo/IPath";
import { v4 as uuidv4 } from "uuid";
import { PositionInTrain } from "../core/planTrainUnitUnitCalculations";

type PlanTrainUnitProps = {
  readonly planTrainUnit: PlanTrainUnit;
  readonly points: Point[];
  readonly trackLineWidth: number;
};

export function EPDPlanTrainUnit({
  planTrainUnit,
  points,
  trackLineWidth,
}: PlanTrainUnitProps): React.JSX.Element {
  const { style } = useEPDStyle();

  const { backgroundColor, textColor } = style.trainTypeColors.getOrDefault(planTrainUnit.kind);

  const unitPaths: { path: IPath; id: string }[] = useMemo(
    () =>
      getUnitPaths(trackLineWidth, points, planTrainUnit.units).map((i) => {
        return { path: i, id: uuidv4() };
      }),
    [points, trackLineWidth, planTrainUnit.units],
  );

  return (
    <Group>
      {unitPaths.map(({ path, id }, index, array) => {
        return (
          <PlanTrainUnitUnit
            key={`EPDPlanTrainUnit-PlanTrainUnitUnit-${id}`}
            position={getPlanTrainPositon(index, array.length)}
            fill={backgroundColor}
            points={path.points}
            width={trackLineWidth * 18}
          />
        );
      })}
      <PlanTrainUnitText
        backgroundColor={backgroundColor}
        backgroundHeight={trackLineWidth * 18 * 0.6}
        mainText={planTrainUnit.name}
        points={points}
        subText={`${planTrainUnit.kind} ${planTrainUnit.units}`}
        textColor={textColor}
        trackLineWidth={trackLineWidth}
      />
    </Group>
  );
}

function getPlanTrainPositon(index: number, length: number): PositionInTrain {
  if (index === 0) {
    return "first";
  }
  if (index === length - 1) {
    return "last";
  }
  return "middle";
}
